module.exports = __webpack_public_path__ + "static/media/abc7.730a2773.jpg";